import { render, staticRenderFns } from "./kv-ai-icon.vue?vue&type=template&id=1316692a"
import script from "./kv-ai-icon.vue?vue&type=script&lang=js"
export * from "./kv-ai-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports